export const PDP = {
    PREV_IMAGE_BUTTON: "pdp-prev-image-btn",
    NEXT_IMAGE_BUTTON: "pdp-next-image-btn",

    THUMBS: "pdp-thumbs",

    THUMBS_PREV: "pdp-thumbs-prev",
    THUMBS_NEXT: "pdp-thumbs-next",

    THUMBS_360: "pdp-thumb-icon-360",
    THUMBS_VIDEO: "pdp-thumb-video",
    THUMBS_THREEDIUM: "pdp-thumb-threedium",
    THUMB_CONTAINER: "pdp-thumb-container",

    JUMBO_IMAGE_360: "pdp-jumbo-image-360",
    JUMBO_VIDEO_PLAY_PAUSE: "pdp-jumbo-video-play-pause",
    JUMBO_VIDEO: "pdp-jumbo-video",

    VIDEO_POSTER: "pdp-video-poster",

    VIEW_IN_LIGHTBOX_BUTTON: "view-in-lightbox-button",

    ACTION_BUTTONS: {
        REMOVE: "remove-from-order",
        ADD: "add-to-order",
        UPDATE: "update-order",
    },

    EDIT_IN_CART_BTN: "edit-in-cart",

    PRODUCT_DETAILS_CONTAINER: "pdp-container",
    IMAGE_MAGNIFY_CONTAINER: "image-magnify-container",
    TRANSFORM_COMPONENT: "transform-component",
    ZOOM_HEADER: "zoom-header",
    ZOOM_IN_BTN: "zoom-in-btn",
    ZOOM_OUT_BTN: "zoom-out-btn",
    ZOOM_CLOSE_BTN: "zoom-close-btn",

    // custom list
    CREATE_NEW_LIST: "bulk-create-new-catalog",
    LIST_NAME_INPUT: "modal-prompt-input",
    CONFIRM_BUTTON: "modal-prompt-confirm",
    CANCEL_BUTTON: "modal-prompt-cancel",
    WAREHOUSE_SELECT: "warehouse-select",
};
